import * as THREE from "three";
import Instruction from "./fw/instruction";
import Utilities from "./fw/utilities";

export default class Globe extends Instruction {
    constructor () {
        super();

        Object.assign(this.s, {
            mountainSlope: 0.985,
            mountainHeight: 1.017,
            hardMountainHeight: 1.023
        });
    }

    setup () {
        var u3 = Utilities.THREE;
        var icoGeo = new THREE.IcosahedronGeometry(1, 1);
        icoGeo.computeVertexNormals();
        var globeGeo = u3.subdivideAndAddRandom(icoGeo, 0.06);
        globeGeo = u3.subdivideAndAddRandom(globeGeo, 0.02);
        globeGeo = u3.subdivideAndAddRandom(globeGeo, 0.01);
        globeGeo = u3.subdivideAndAddRandom(globeGeo, 0.005);

        globeGeo = this.enhanceMountains(globeGeo, 0.006);

        globeGeo = u3.subdivideAndAddRandom(globeGeo, 0.0025, undefined, false);

        globeGeo = this.enhanceMountains(globeGeo, 0.003);

        this.colourise(globeGeo);

        var globeMat = new THREE.MeshPhongMaterial({color: 0xffffff, wireframe:false, vertexColors: THREE.VertexColors});

        this.a.land = new THREE.Mesh(globeGeo, globeMat);

        var waterGeo = new THREE.SphereGeometry(1.012, 32, 24);
        var waterMat = new THREE.MeshPhongMaterial({color: 0x3030b0});

        this.a.water = new THREE.Mesh(waterGeo, waterMat);

        this.a.scene = new THREE.Object3D();

        this.a.scene.add(this.a.land);
        this.a.scene.add(this.a.water);

        var sources = this.getSourceVertices(globeGeo);

        for (var i = 0; i < sources.length; ++i) {
            var markerGeo = new THREE.IcosahedronGeometry(0.01,1);
            var markerMat = new THREE.MeshPhongMaterial();

            var marker = new THREE.Mesh(markerGeo, markerMat);

            marker.position.copy(globeGeo.vertices[sources[i]]);

            this.a.scene.add(marker);
        }
    }

    enhanceMountains (geometry, range) {
        var mountains = [];
        for (var i = 0; i < geometry.faces.length; ++i) {
            var f = geometry.faces[i];
            var middle = (new THREE.Vector3()).copy(geometry.vertices[f.a])
                                              .add(geometry.vertices[f.b])
                                              .add(geometry.vertices[f.c])
                                              .divideScalar(3);

            var height = middle.length();
            if (height > this.s.hardMountainHeight || height > this.s.mountainHeight &&
                    middle.normalize().dot(f.normal)+(Math.random()-0.5)*0.01 < this.s.mountainSlope)
                mountains.push(i);
        }

        var newgeometry = Utilities.THREE.subdivideAndAddRandom(geometry, range, mountains);

        return newgeometry;
    }

    colourise (geometry) {
        for (var i = 0; i < geometry.faces.length; ++i) {
            var f = geometry.faces[i];

            f.vertexColors[0] = this.assignColour(geometry.vertices[f.a], f.vertexNormals[0]);
            f.vertexColors[1] = this.assignColour(geometry.vertices[f.b], f.vertexNormals[1]);
            f.vertexColors[2] = this.assignColour(geometry.vertices[f.c], f.vertexNormals[2]);
        }
    }

    assignColour (vertex, vertexNormal) {
        var v = vertex.clone();
        var vn = vertexNormal.clone();

        var colour = new THREE.Color();

        var plains = new THREE.Color(0x30b030);
        var mountain = new THREE.Color(0x605040);
        var polar = new THREE.Color(0xfafaff);

        var height = v.length();

        colour.copy(plains);
        colour.lerp(mountain, Utilities.smoothStep(height, this.s.mountainHeight+0.0055, this.s.mountainHeight+0.006));
        colour.lerp(polar, Utilities.smoothStep(height, this.s.hardMountainHeight+0.005, this.s.hardMountainHeight+0.01));
        colour.lerp(polar, Utilities.smoothStep(Math.abs(v.y), 0.75, 0.85));

        return colour;
    }

    getSourceVertices (geometry) {
        var exits = Array.apply(null, Array(geometry.vertices.length)).map(Number.prototype.valueOf, 0);
        var rating = Array.apply(null, Array(geometry.vertices.length)).map(Number.prototype.valueOf, 0);

        var a = new THREE.Vector3(),
            b = new THREE.Vector3(),
            c = new THREE.Vector3(),
            centre = new THREE.Vector3(),
            a_centre = new THREE.Vector3(),
            b_centre = new THREE.Vector3(),
            c_centre = new THREE.Vector3();

        for (var i = 0; i < geometry.faces.length; ++i) {
            var f = geometry.faces[i];

            a.copy(geometry.vertices[f.a]);
            b.copy(geometry.vertices[f.b]);
            c.copy(geometry.vertices[f.c]);

            centre.copy(a).add(b).add(c).divideScalar(3);

            a_centre.copy(centre).sub(a).normalize();
            b_centre.copy(centre).sub(b).normalize();
            c_centre.copy(centre).sub(c).normalize();

            var adot = a_centre.dot(a),
                bdot = b_centre.dot(b),
                cdot = c_centre.dot(c);

            if (adot < 0) exits[f.a] += 1;
            else rating[f.a] += adot;
            if (bdot < 0) exits[f.b] += 1;
            else rating[f.b] += bdot;
            if (cdot < 0) exits[f.c] += 1;
            else rating[f.c] += cdot;
        }

        var verts = new Array(geometry.vertices.length);

        for (var i = 0; i < geometry.vertices.length; ++i) verts[i] = i;

        verts.sort((a,b) => rating[a] < rating[b] ? 1 : rating[a] > rating[b] ? -1 : 0);

        var sources = [];

        for (var i = 0; sources.length < 20 && i < geometry.vertices.length; ++i) {
            if (exits[verts[i]] > 0 && exits[verts[i]] < 3) sources.push(verts[i]);
        }

        return sources;
    }
}
